<div class="loadingio-spinner-disk-jhr6ag37jwg">
    <div class="ldio-6fndo9utzeb">
        <div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>

<style type="text/css">
    @keyframes ldio-6fndo9utzeb {
        0% {
            transform: rotate(0deg)
        }
        100% {
            transform: rotate(360deg)
        }
    }

    .ldio-6fndo9utzeb > div > div {
        position: absolute;
        border-radius: 50%;
    }

    .ldio-6fndo9utzeb > div > div:nth-child(1) {
        top: 15px;
        left: 15px;
        width: 70px;
        height: 70px;
        background: #ff6600;
    }

    .ldio-6fndo9utzeb > div > div:nth-child(2) {
        top: 19.9px;
        left: 39.5px;
        width: 21px;
        height: 21px;
        background: #ffe0cc;
        animation: ldio-6fndo9utzeb 1s linear infinite;
        transform-origin: 10.5px 30.1px;
    }

    .loadingio-spinner-disk-jhr6ag37jwg {
        width: 50px;
        height: 50px;
        margin: 0 auto;
        overflow: hidden;
        background: transparent;
    }

    .ldio-6fndo9utzeb {
        width: 100%;
        height: 100%;
        position: relative;
        transform: translateZ(0) scale(0.5);
        backface-visibility: hidden;
        transform-origin: 0 0; /* see note above */
    }

    .ldio-6fndo9utzeb div {
        box-sizing: content-box;
    }

    /* generated by https://loading.io/ */
</style>